/**
 * home.js
 * 用于home模块的状态管理
 */
import * as types from '@/store/mutation-type'
const home = {
  state: {
    number: 1
  },
  mutations: {
    [types.SET_NUM] (state, num) {
      state.number = num
    }
  },
  actions: {},
  getters: {
    number: state => {
      return state.number
    }
  }
}
export default home



// WEBPACK FOOTER //
// ./src/store/modules/home.js